export const productionGeneratorGroupStatuses = {
  WAITING: 'Várakozik',
  PROCESSING: 'Feldolgozás alatt',
  COMPLETED: 'Elkészült',
  FAILED: 'Hibás',
  INTERRUPTED: 'Hibás',
};

export const productionGeneratorGroupColors = {
  WAITING: '#e3f2fd',
  PROCESSING: '#fff9c4',
  FAILED: '#ffebee',
  INTERRUPTED: '#ffebee',
};
